
export default {
    name: 'StartBankIcon',
    props: {
        riskLevel: String,
    },
    computed: {
        styles() {
            let color = '#757575'

            if (this.riskLevel === 'high') {
                color = '#ef3b39'
            } else if (this.riskLevel === 'medium') {
                color = '#ffa630'
            } else if (this.riskLevel === 'low') {
                color = '#45b649'
            }

            return { color }
        },
    },
}
